import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: string;
    detailsNoPermission: (ownerEmail: string) => string | React.ReactNode;
    detailsWithPermission: () => string | React.ReactNode;
};
export type Deps = {
    UniversalLink: any;
    SETTINGS_BILLING: any;
};
export default {
    DEFINE(_messages: Text, { UniversalLink, SETTINGS_BILLING }: Deps): void {
        return Object.defineProperties(this, {
            /** Banner title */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PaymentAlertBanner.title?c=m2oyv4gxo104", defaultMessage: "Payment Problem" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Message for users without billing permissions */
            detailsNoPermission: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (ownerEmail: string) => __intl__.intl().formatMessage({ id: "PaymentAlertBanner.detailsNoPermission?c=2zh8s2bg1h10f", defaultMessage: "<jsx>Contact account owner  <UniversalLink>({ownerEmail})</UniversalLink>  for assistance or account will be locked.</jsx>" }, { jsx: (__children__: React.ReactNode) => React.Children.toArray(__children__), UniversalLink: (__children__: React.ReactNode) => <UniversalLink href={`mailto:${ownerEmail}`} target="_blank">{React.Children.toArray(__children__)}</UniversalLink>, ownerEmail: ownerEmail }));
                },
                enumerable: true,
                configurable: true
            },
            /** Message for users with billing permissions */
            detailsWithPermission: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => () => __intl__.intl().formatMessage({ id: "PaymentAlertBanner.detailsWithPermission?c=o8vgql8bqfj4", defaultMessage: "<jsx><UniversalLink>Update payment method</UniversalLink>  to try again or account will be locked.</jsx>" }, { jsx: (__children__: React.ReactNode) => React.Children.toArray(__children__), UniversalLink: (__children__: React.ReactNode) => <UniversalLink href={SETTINGS_BILLING}>{React.Children.toArray(__children__)}</UniversalLink> }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps: Deps): void;
};
